import { Link } from "react-router-dom";

export const InnovationAndProjectThinkingInHigherEducationConst = {
  path: "/single-page/innovation-and-project-thinking-in-higher-education",
  title: "ИННОВАЦИИ И ПРОЕКТНОЕ МЫШЛЕНИЕ В ВЫСШЕМ ОБРАЗОВАНИИ",
  contentJSX: (
    <>
      <h2>Инновации и проектное мышление в высшем образовании</h2>
      <p>Общий объём: 144 академических часа</p>
      <p>Формат: онлайн / офлайн / выездной интенсив</p>
      <p>Язык: русский / английский</p>
      <p>Итог: Международный сертификат</p>
      <h2>I. ИННОВАЦИИ В ПЕДАГОГИКЕ И ОБРАЗОВАНИИ — 36 ЧАСОВ</h2>
      <ul className="number">
        <li>Мировые тренды в обучении – 12 ч</li>
        <li>EdTech, мобильные платформы, гибкие модели – 12 ч</li>
        <li>Образовательные стартапы и корпоративные решения – 12 ч</li>
      </ul>
      <h2>II. ПРОЕКТНОЕ МЫШЛЕНИЕ И ДИЗАЙН-МЫСЛИТЕЛЬНЫЕ МЕТОДИКИ — 36 ЧАСОВ</h2>
      <ul className="number">
        <li>Design Thinking: фреймворк и практика – 12 ч</li>
        <li>Lean Startup и agile-подход в образовании – 12 ч</li>
        <li>Rapid prototyping образовательных решений – 12 ч</li>
      </ul>
      <h2>III. СОЗДАНИЕ АВТОРСКИХ КУРСОВ И МОДУЛЕЙ — 36 ЧАСОВ</h2>
      <ul className="number">
        <li>Canvas и ABC model – 12 ч</li>
        <li>Креативные задания и системы оценивания – 12 ч</li>
        <li>Визуализация и storytelling – 12 ч</li>
      </ul>
      <h2>IV. ГРУППОВАЯ РАБОТА И УПРАВЛЕНИЕ ОБРАЗОВАТЕЛЬНЫМИ ПРОЕКТАМИ — 24 ЧАСА</h2>
      <ul className="number">
        <li>Проектная команда и роли – 6 ч</li>
        <li>Организация проектных лабораторий – 6 ч</li>
        <li>Scrum и Kanban – 6 ч</li>
        <li>Рефлексия и документация – 6 ч</li>
      </ul>
      <h2>V. ИТОГОВЫЙ ПРОЕКТ — 12 ЧАСОВ</h2>
      <ul className="number">
        <li>Разработка и презентация инновационного решения – 6 ч</li>
        <li>Peer-review и план внедрения – 6 ч</li>
      </ul>
      <br />
      <Link to={"/apply-online"} className="btn-default reverse">
        Оставить заявку
      </Link>
    </>
  ),
  contentSearch: `

  `,
};
